<app-navbar *ngIf="!WRONG_SUBDOMAIN"></app-navbar>
<app-spinner></app-spinner>
<div class="container-xxl bg-white p-0">
  <div id="TOP"></div>
  <router-outlet />
  <!-- Back to Top -->
  <a
    class="btn btn-lg btn-primary btn-lg-square back-to-top"
    (click)="navigateToTop()"
    ><i class="bi bi-arrow-up"></i
  ></a>
</div>
<app-footer *ngIf="!WRONG_SUBDOMAIN"></app-footer>
